export const IOS_APP_LINK =
  'https://apps.apple.com/us/app/kudos-fit/id1469977012'
export const ANDROID_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.kudos.fit'
